import { configureStore } from "@reduxjs/toolkit";
import { baseAPI } from "./BaseAPI";
import { adminBaseAPI } from "./AdminBaseAPI";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { documentBaseAPI } from "./DocumentBaseAPI";
import conversationReducer from "./Slice/ConversationSlice";
import { messageCenterBaseApi } from "./MessageCenterBaseAPI";

export const store = configureStore({
  reducer: {
    // Add the API reducer here
    [baseAPI.reducerPath]: baseAPI.reducer,
    [adminBaseAPI.reducerPath]: adminBaseAPI.reducer,
    [documentBaseAPI.reducerPath]: documentBaseAPI.reducer,
    [messageCenterBaseApi.reducerPath]: messageCenterBaseApi.reducer,
    conversation: conversationReducer,
  },
  middleware: (getDefaultMiddleware) =>
    // Concatenate the baseAPI middleware with the default middleware
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["bugTrackerFile/addUploadReadyFile", "bugTrackerFile/addFile"],
        ignoredPaths: ["bugTrackerFile"],
      },
    }).concat(baseAPI.middleware, adminBaseAPI.middleware, documentBaseAPI.middleware, messageCenterBaseApi.middleware),
});

// Optional: Export store's types for better TypeScript support
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
